/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, IconButton, styled } from "@mui/material";
import { FC, PropsWithChildren, useState, useEffect } from "react";
import { ReactComponent as MenuCloser } from "assets/Menu_Close.svg";

interface Props {
  open?: boolean;
  onClose: () => void;
}

const Drawer = styled(Box)({
  flexShrink: 0,
  position: "relative",
  maxWidth: "0%",
  overflow: "visible",
  "&.opened": {
    transition: "max-width 0.3s ease-out",
    maxWidth: "50%",
  },
});

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(0.5),
  left: -75,
  display: "none",
  "&.opened": {
    display: "blocked",
  },
}));

const Container = styled("div")({
  height: "100%",
  borderLeft: "1px solid rgba(0, 0, 0, 0.5)",
  boxShadow: "-4px 0px 4px 0px rgba(0, 0, 0, 0.25)",
  overflow: "hidden",
});
export const SideDrawer: FC<PropsWithChildren<Props>> = ({
  open,
  onClose,
  children,
}) => {
  const [openedClassName, setOpenedClassName] = useState<string>("");

  useEffect(() => {
    setOpenedClassName(open ? "opened" : "");
  }, [open]);

  return (
    <Drawer className={openedClassName}>
      <CloseButton className={openedClassName} onClick={onClose}>
        <MenuCloser />
      </CloseButton>
      <Container>{children}</Container>
    </Drawer>
  );
};
